module.exports = __webpack_public_path__ + "img/paket-2.fbb88ff9.png";